// eslint-disable-next-line no-shadow
enum ZOHO_DOCUMENT_STATUS {
  COMPLETED = 'completed',
  INCOMPLETE = 'incomplete',
}

export { ZOHO_DOCUMENT_STATUS };
